import { SCROLL_Y_BREAKPOINTS } from "../../constants";

/*---------------------------
| Animation Props
---------------------------*/
const SPEED = 300;
const SPEED_FADE_IN = 300;
const SPEED_FADE_OUT = 0;
const TOP_OFFSET = 75;

const getPageProps = currentPage => {
    const scrollYBreakpoint =
        SCROLL_Y_BREAKPOINTS?.[currentPage]?.row2Animate ||
        SCROLL_Y_BREAKPOINTS.default.row2Animate;
    let topIsAnimated = false;
    let overflow = {
        isVisible: true,
        shouldToggle: false
    };

    switch (currentPage) {
        case "home":
        case "icons":
        case "photos":
            topIsAnimated = true;
            overflow = {
                isVisible: false,
                shouldToggle: true
            };
            break;
        default:
            break;
    }

    return { scrollYBreakpoint, topIsAnimated, overflow };
};

// Get Animate IN props
const getAnimateInProps = (topIsAnimated, isLoggedIn) => {
    return {
        // Vertical :: when !topIsAnimated we exclude
        top: { value: 0, speed: topIsAnimated ? SPEED : 0, delay: 0 },

        // Overlay
        left: {
            value: 125,
            speed: SPEED,
            delay: topIsAnimated ? SPEED * 1 : 0
        },
        right: {
            value: isLoggedIn ? 148 : 175,
            speed: SPEED,
            delay: topIsAnimated ? SPEED * 1 : 0
        },

        // Underlay
        opacity: {
            value: 1,
            speed: SPEED_FADE_IN,
            delay: topIsAnimated ? SPEED * 2 : SPEED * 1
        }
    };
};

// Get Animate OUT props
// Also an alias for default props
const getAnimateOutProps = topIsAnimated => {
    return {
        // Vertical :: when !topIsAnimated we exclude, when topIsAnimated it gets pushed down offstage
        top: {
            value: topIsAnimated ? TOP_OFFSET : 0,
            speed: topIsAnimated ? SPEED : 0,
            delay: SPEED * 1
        },

        // Overlay
        left: { value: 0, speed: SPEED, delay: 0 },
        right: { value: 0, speed: SPEED, delay: 0 },

        // Underlay
        opacity: { value: 0, speed: SPEED_FADE_OUT, delay: 0 }
    };
};

// When Animating In, we need to wait for animation to complete before we set overflow: visible;
// animateInProps.opacity delay plus speed === total duration of animation in
const getOverflowAnimateInDuration = (pagePropsOverflow, animateInProps) => {
    const { delay, speed } = animateInProps.opacity;
    const animatinInDuration = delay + speed;
    return {
        ...pagePropsOverflow,
        animatinInDuration
    };
};

const getAnimateProps = (currentPage, isLoggedIn) => {
    const pageProps = getPageProps(currentPage);
    const { topIsAnimated, scrollYBreakpoint } = pageProps;
    const animateInProps = getAnimateInProps(topIsAnimated, isLoggedIn);
    const animateOutProps = getAnimateOutProps(topIsAnimated);
    const overflow = getOverflowAnimateInDuration(
        pageProps.overflow,
        animateInProps
    );
    return {
        styleProps: animateOutProps, // default to animateOutProps
        animateInProps,
        animateOutProps,
        sequence: "out",
        scrollYBreakpoint,
        overflow
    };
};

export default getAnimateProps;
